import { render } from "./UserField.vue?vue&type=template&id=2a4821e9&scoped=true"
import script from "./UserField.vue?vue&type=script&lang=js"
export * from "./UserField.vue?vue&type=script&lang=js"

import "./UserField.vue?vue&type=style&index=0&id=2a4821e9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4821e9"]])

export default __exports__